exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-merch-index-tsx": () => import("./../../../src/pages/merch/index.tsx" /* webpackChunkName: "component---src-pages-merch-index-tsx" */),
  "component---src-pages-merch-thankyou-tsx": () => import("./../../../src/pages/merch/thankyou.tsx" /* webpackChunkName: "component---src-pages-merch-thankyou-tsx" */),
  "component---src-pages-shows-index-tsx": () => import("./../../../src/pages/shows/index.tsx" /* webpackChunkName: "component---src-pages-shows-index-tsx" */)
}

